import { createContext } from "react";
import { useTooltip } from "@/components/Tooltip/useTooltip";
import { Placement } from "@floating-ui/react";

type ContextType = ReturnType<typeof useTooltip> | null;

export const TooltipContext = createContext<ContextType>(null);

export interface TooltipOptions {
  initialOpen?: boolean;
  placement?: Placement;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  openDelay?: number;
  closeDelay?: number;
  showOnCreate?: boolean;
}
